import {
  Box,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@mui/material";
import React from "react";
import { useMessages } from "./MessagesContext";
import { MessageModel } from "./utils";

const MessageFilter = () => {
  const {
    filters,
    filterValues,
    setFilters,
    setSelectedMessage,
    setMessage,
    setViewAllLogs,
  } = useMessages();

  const handleFilterChange = (e) => {
    const name = e.target.name;
    const checked = e.target.checked;
    setFilters((prev) => ({ ...prev, [name]: checked }));
  };

  if (
    filterValues.activeOnly !== null &&
    filterValues.includeIncidentMessages !== null
  )
    return (
      <Box>
        <Typography variant="h5" sx={{ mb: 2, textAlign: "center", mt: 2 }}>
          Manage Messages
        </Typography>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="right"
          sx={{ mb: 2 }}
        >
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  name="activeOnly"
                  checked={filters.activeOnly}
                  onChange={handleFilterChange}
                />
              }
              label="Active Only"
            />
          </Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  name="includeIncidentMessages"
                  checked={filters.includeIncidentMessages}
                  onChange={handleFilterChange}
                />
              }
              label="Include Incident Messages"
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              onClick={(e) => setMessage(MessageModel)}
            >
              Create New Message
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" onClick={() => setViewAllLogs(true)}>
              View All Logs
            </Button>
          </Grid>
        </Grid>
      </Box>
    );
};

export default MessageFilter;
